export const params = new URLSearchParams(window.location.search);

export const appVersion = params.get("appVersion");
export const riderId = params.get("riderId");
export const riderToken = params.get("token");
export const riderTokenNew = params.get("tokenNew");
export const defaultSize = params.get("size");
